<template>
  <lateral-modal
    :title="$t('merchants_merchant_detail_header')"
    @close="closeModal"
  >
    <template slot="content">
      <div class="d-flex justify-content-between align-items-center flex-column my-2 w-100">
        <user-avatar-uploader
          class="uploader-block"
          :imageClass="'merchant-icon'"
          :userName="merchantName"
          :profilePictureId.sync="currentMerchantLogo"
          @avatarChange="uploadLogo"
        ></user-avatar-uploader>
      </div>
      <div class="my-3">
        <div class="input--block input--block--margin input--block--padded">
          <label
            for=""
            class="form--label"
          >{{$t('merchant_merchant_name').toUpperCase()}}</label>
          <div class="Form-field">

            <input
              type="text"
              name="merchant-show-name"
              id="merchant-show-name"
              v-model="merchantName"
              class="Input-text"
            >
          </div>
        </div>
        <div class="input--block input--block--margin input--block--padded">
          <label
            for=""
            class="form--label"
          >{{$t('merchant_merchant_social_reason').toUpperCase()}}</label>
          <div class="Form-field">

            <input
              type="text"
              name="merchant-social-reason"
              id="merchant-social-reason"
              disabled
              v-model="merchantSocialReason"
              class="Input-text"
            >
          </div>
        </div>
        <div class="input--block input--block--margin input--block--padded">
          <label
            for=""
            class="form--label"
          >{{$t('merchant_merchant_cif').toUpperCase()}}</label>
          <div class="Form-field">

            <input
              type="text"
              name="merchant-cif"
              id="merchant-cif"
              disabled
              v-model="merchantCif"
              class="Input-text"
            >
          </div>
        </div>
        <div class="input--block input--block--margin input--block--padded">
          <label
            for=""
            class="form--label"
          >{{$t('merchant_merchant_identifiers').toUpperCase()}}</label>
          <div class="Form-field">
            <input
              type="text"
              name="merchant-cif"
              id="merchant-cif"
              disabled
              v-model="merchantIds"
              class="Input-text"
            >
          </div>
        </div>

        <div class="matchers">
          <label class="form--label">{{$t('merchant_merchant_matchers').toUpperCase()}}</label>
          <merchant-matcher
            @delete="deleteMatcher(matcher)"
            v-model="merchantMatchers[i]"
            v-for="(matcher, i) in merchantMatchers"
            :key="i"
          ></merchant-matcher>
          <button
            class="Fuell-Button"
            @click="addMatcher()"
          >
            <span
              class="Fuell-Button--label"
              v-t="{path: 'merchant_merchant_add_matcher'}"
            ></span>
          </button>
        </div>

        <div class="save-button-container">
          <button
            class="Fuell-Button block blue"
            @click="updateMerchant()"
          >
            <span
              class="Fuell-Button--label"
              v-t="{path: 'ACTION_SAVE'}"
            ></span>
          </button>
        </div>
      </div>
    </template>
  </lateral-modal>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _merchantsMixin from '@/modules/merchants/_mixins/_merchantsMixin'
import UserAvatarUploader from '@/modules/users/_components/profile/UserAvatarUploader'
import MerchantMatcher from '@/modules/merchants/_components/merchants/MerchantMatcher'
import LateralModal from '@/components/Commons/Modals/LateralModal'

export default {
  name: 'MerchantDetailModal',
  mixins: [_modalHandlerMixin, _merchantsMixin],
  components: {
    MerchantMatcher,
    UserAvatarUploader,
    LateralModal
  },
  props: {
    merchantId: {
      type: Number
    }
  },
  data () {
    return {
      isFetchingMerchant: false,
      merchantName: '',
      merchantMatchers: [],
      merchantSocialReason: '',
      merchantCif: '',
      merchantIds: ''
    }
  },
  computed: {
    currentMerchant () {
      return this.$store.getters['MerchantsStore/currentMerchant']
    },
    currentMerchantLogo () {
      return this.currentMerchant && this.currentMerchant.logo ? this.currentMerchant.logo.id : null
    }
  },
  methods: {
    async fetchMerchant () {
      if (this.merchantId) {
        try {
          await this.$store.dispatch('MerchantsStore/fetchMerchant', this.merchantId)
          this.merchantName = this.currentMerchant.name
          this.merchantMatchers = this.parseMatchers(this.currentMerchant.matchers)
          this.merchantSocialReason = this.currentMerchant.businessName
          this.merchantCif = this.currentMerchant.registrationNumber
          this.merchantIds = this.currentMerchant.merchantIdentifiers.join(',')
        } catch (error) {
          this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'merchants_fetch_merchant_error' })
        }
      } else {
        this.merchantName = ''
        this.merchantMatchers = []
        this.merchantSocialReason = ''
        this.merchantCif = ''
        this.merchantIds = []
      }
    },
    async uploadLogo (file) {
      try {
        await this.$store.dispatch('MerchantsStore/updateMerchantLogo', { merchantId: this.merchantId, merchantLogo: file })
        this.$store.dispatch('SnackBars/addSuccess', this.$t('merchants_update_logo_success'))
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'merchants_update_logo_error' })
      }
    },
    async updateMerchant () {
      // TODO: when v2 add rest of the fields
      let merchantData = {
        name: this.merchantName,
        matchers: this.getRegexMatchers(this.merchantMatchers)
      }
      if (this.merchantId) {
        try {
          await this.$store.dispatch('MerchantsStore/updateMerchant', { merchantId: this.merchantId, merchantData: merchantData })
          this.$store.dispatch('SnackBars/addSuccess', this.$t('merchants_update_merchant_success'))
        } catch (error) {
          this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'merchants_update_merchant_error' })
        }
      } else {
        try {
          const response = await this.$store.dispatch('MerchantsStore/createMerchant', { merchantData: merchantData })
          this.$store.dispatch('SnackBars/addSuccess', this.$t('merchants_create_merchant_success'))
          this.$emit('created', response.id)
        } catch (error) {
          this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'merchants_create_merchant_error' })
        }
      }
    },
    addMatcher () {
      this.merchantMatchers.push({
        text: '',
        caseInsensitive: true
      })
    },
    deleteMatcher (matcher) {
      this.merchantMatchers.splice(this.merchantMatchers.indexOf(matcher), 1)
    }
  },
  watch: {
    merchantId: async function (newV, oldV) {
      await this.fetchMerchant()
    }
  },
  created () {
    this.fetchMerchant()
  }
}
</script>

<style scoped>
.uploader-block {
  width: 120px;
  height: 120px;
  max-width: 120px;
  max-height: 120px;
}
.uploader-block >>> .camera {
  top: 48px;
  left: 48px;
}
.uploader-block >>> .Thumb--72 {
  flex: 0 0 120px;
  height: 120px;
  width: 120px;
}
.matchers {
  padding: 5px;
}
.save-button-container {
  position: absolute;
  margin: 15px;
  padding: 5px;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
<style>
.merchant-icon {
  object-fit: contain;
  max-width: 120px !important;
  max-height: 120px !important;
  width: 120px !important;
  height: 120px !important;
  border-radius: 50% !important;
  border: 5px solid var(--gray-light) !important;
}
</style>
